<template>
    <div>
        <p class="error">{{error}}</p>
        <p class="decode-result"><b>{{result}}</b></p>
        <qrcode-stream @decode="onDecode" @init="onInit"/>
    </div>
</template>

<script>
export default {
  name: 'QRScanner',
  data () {
    return {
      result: '',
      error: ''
    }
  },
  methods: {
    onDecode (result) {
      this.result = result
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        switch (error.name) {
          case 'NotAllowedError':
            this.error = 'ERROR: you need to grant camera access permission'
            break
          case 'NotFoundError':
            this.error = 'ERROR: no camera on this device'
            break
          case 'NotSupportedError':
            this.error = 'ERROR: secure context required (HTTPS, localhost)'
            break
          case 'NotReadableError':
            this.error = 'ERROR: is the camera already in use?'
            break
          case 'OverconstrainedError':
            this.error = 'ERROR: installed cameras are not suitable'
            break
          case 'StreamApiNotSupportedError':
            this.error = 'ERROR: Stream API is not supported in this browser'
            break
          default:
            this.error = 'ERROR: ' + error.name
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .error {
        font-weight:bold;
        color:red;
    }
</style>



// WEBPACK FOOTER //
// src/components/devices/new/QRScanner.vue